const { transfer_group_owner } = require("../../sdk/config/api");

var $link = null;
var _isEmpty = function (input) {
  return input + '' === 'null' || input + '' === 'undefined' || input === '';
};
var _isGroupUser = function (contact) {
  return contact && contact.user_source && Number(contact.user_source) > 10000;
};
var _isShopModeUserSource = function (source) {
  return !_isEmpty(source) && Number(source) == 9999;
}
var _isShopModeUser = function (obj, me) {
  var isShopModeUser = false;
  if (_isEmpty(obj)) {
    isShopModeUser = false;
  } else if (!_isEmpty(obj.is_shop_mode) && obj.is_shop_mode) {
    // user判断
    isShopModeUser = true;
  } else if (!_isEmpty(obj.sender_source) && !_isEmpty(obj.to_source)) {
    // msg判断
    var isShopModeUserSource = _isShopModeUserSource(obj.sender_source) || _isShopModeUserSource(obj.to_source);
    var sendKey = obj.sender_id + '@' + obj.sender_source;
    var toKey = obj.to_id + '@' + obj.to_source;
    var meKey = me ? me.user_id + '@' + me.user_source : null;
    isShopModeUser = isShopModeUserSource && meKey && sendKey != meKey && toKey != meKey;
  } else if (!_isEmpty(obj.user_source)) {
    // contact判断
    isShopModeUser = _isShopModeUserSource(obj.user_source);
  }
  return isShopModeUser;
}
var _getShopKey = function (msg, me) {
  if (_isEmpty(msg) || !_isShopModeUser(msg, me)) {
    return null;
  }
  var sendKey = msg.sender_id + '@' + msg.sender_source;
  var toKey = msg.to_id + '@' + msg.to_source;
  return _isShopModeUserSource(msg.sender_source) ? sendKey : _isShopModeUserSource(msg.to_source) ? toKey : null;
}
var _jsonHandler = {};
_jsonHandler.parse = function (data) {
  try {
    data = JSON.parse(data);
  } catch (e) {
    data = {};
  }
  return data;
};
_jsonHandler.stringify = function (data) {
  try {
    data = JSON.stringify(data);
  } catch (e) {
    data = '';
  }
  return data;
};
/*string转换为number,进行比较*/
var _strToNumCompare = function (str1, str2) {
  var result = 0;
  var nagative;
  if (!str1 && !str2) {
    return result;
  }
  if (isNaN(str1) || isNaN(str2)) {
    return null;
  }

  str1 = str1 + '';
  str2 = str2 + '';
  // 负数
  if (str1.charAt(0) == '-' && str2.charAt(0) != '-') {
    result = -1;
    return result;
  } else if (str1.charAt(0) != '-' && str2.charAt(0) == '-') {
    result = 1;
    return result;
  }
  if (str1.charAt(0) == '-' && str2.charAt(0) == '-') {
    str1 = str1.substring(1);
    str2 = str2.substring(1);
    nagative = true;
  }
  var len1 = str1.length;
  var len2 = str2.length;
  if (len1 > len2) {
    result = 1;
  } else if (len1 < len2) {
    result = -1;
  } else if (len1 == len2) {
    for (var i = 0; i < len1; i++) {
      if (str1[i] > str2[i]) {
        result = 1;
        break;
      } else if (str1[i] < str2[i]) {
        result = -1;
        break;
      } else if (str1[i] == str2[i]) {
        continue;
      }
    }
  }

  if (nagative) {
    result = result == 1 ? -1 : result == -1 ? 1 : 0;
  }
  return result;
};

var queque = function (size) {
  var _size = 0;
  if (!isNaN(size)) {
    _size = Number(size);
  }
  var _queque = [];
  return {
    store: function (objs) {
      if (objs instanceof Array) {
        _queque = objs;
      }
    },
    add: function (obj) {
      if (_size) {
        if (_queque.length + 1 > _size) {
          _queque.shift();
        }
        _queque.push(obj);
      }
    },
    cut: function (callback) {
      if (_queque.length > _size) {
        var deleted = _queque.slice(0, _queque.length - _size);
        _queque = _queque.slice((_queque.length - _size || 0), _queque.length);
        callback && callback(deleted, _queque);
      }
    },
    remove: function (index, callback) {
      if (!isNaN(index) && index >= 0 && index <= _queque.length - 1) {
        _queque.splice(index, 1);
      }
      callback && callback(_queque);
    },
    len: function () {
      return _queque.length;
    },
    update: function (index, callback) {
      if (!isNaN(index) && index >= 0 && index <= _queque.length - 1 && typeof callback === 'function') {
        _queque[index] = callback(_queque[index]);
      }
    },
    push: function (objs, callback) {
      if (objs instanceof Array) {
        _queque = _queque.concat(objs);
        this.cut(callback);
      }
    },
    pull: function () {
      return _queque;
    }
  }
}

var _compareBigNumber = function (a, b) {
  var res = 0,
    a = a.split('');
  b = b.split('');
  if (a.length > b.length) {
    return 1;
  } else if (a.length < b.length) {
    return -1;
  } else {
    while (a.length || b.length) {
      let temp = ~~a.pop() - ~~b.pop();
      if (temp === 0) {
        continue;
      } else if (temp > 0) {
        res = 1;
        break;
      } else if (temp < 0) {
        res = -1;
        break;
      }
    }
  }
  return res;
}

var asynchPipe = (function () {
  var pipe = function (fun) {
    this.row = [];
    this.options = {
      status: 0,
      index: 0
    };
    var resolve = this.resolve.bind(this);
    var reject = this.reject.bind(this);
    fun && fun(resolve, reject);
  };
  pipe.prototype.of = function () {
    var _this = this;
    var _pipe = new pipe();
    _pipe.row = this.row;
    _pipe.options = {
      status: 0,
      index: 0
    };
    return _pipe;
  };
  pipe.prototype.resolve = function () {
    if (this.options.status == 3) return;
    var _arguments = Array.prototype.slice.apply(arguments);
    this.options.status = 1;
    this.resolve_val = _arguments;
    if (this.options.index >= this.row.length) return;
    this.options.status = 3;
    var _this = this.row[this.options.index];
    if (_this && _this.success.apply(_this, _arguments));
  };
  pipe.prototype.reject = function (val) {
    if (this.options.status == 3) return;
    var _arguments = Array.prototype.slice.apply(arguments);
    this.options.status = 2;
    this.reject_val = _arguments;
    if (this.options.index >= this.row.length) return;
    this.options.status = 3;
    var _this = this.row[this.options.index];
    if (_this && _this.fail.apply(_this, _arguments));
  };
  pipe.prototype.then = function (success, fail) {
    var _pipe = this.of(success, fail);
    _pipe.options.index = this.options.index + 1;
    _pipe.success = success;
    _pipe.fail = fail;
    this.row.push(_pipe);
    if (this.options.status == 1) {
      _pipe.success.apply(_pipe, this.resolve_val);
    } else if (this.options.status == 2) {
      _pipe.fail.apply(_pipe, this.reject_val);
    }
    return _pipe;
  };
  return pipe;
})();

var _isAnonymousSession = function (user) {
  return user && user.register == 0 && !_isGroupUser(user) && !_isShopModeUser(user)
}

var _ymdhFormat = function (timestamp) {
  try {
    var time = new Date(timestamp);
    var y = time.getFullYear();
    var m = time.getMonth()+1;
    var d = time.getDate();
    var h = time.getHours();
    var wd = time.getDay();
    var mm = time.getMinutes();
    var wdMap = {
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
      0: '周日',
    }
    // var mm = time.getMinutes();
    // var s = time.getSeconds();
    /* 2020年12月2日周三 14:00 */
    if (mm === 0){ mm = '00'};
    return y + '年' + m + '月' + d +'日' + wdMap[wd] + ' ' + h + ':' + mm;
  } catch(e) {
    return ''
  }
}
var _isObjectValueEqual = function (a, b) {
  try {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length) {
      return false;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      var propA = a[propName];
      var propB = b[propName];
      // 故先判断两边都有相同键名
      if (!b.hasOwnProperty(propName)) return false
      if ((typeof (propA) === 'object') && !_isEmpty(propA)) {
        if (!_isObjectValueEqual(propA, propB)) {
          return false
        }
      } else if (propA !== propB) {
        return false
      }
    }
    return true
  } catch (e) {
    return true
  }
}

module.exports = {
  openPage: function (url, target, classname, windowJump) {
    target = target || '_blank';
    if (windowJump) {
      if (target === '_blank') {
        top.open(url);
      } else {
        top.location.href = url;
      }
    }
    if (!$link) {
      $link = $('<a>').css({
        display: 'hidden'
      }).appendTo($('body'));
    }

    $link.attr({
      href: url,
      target: target,
      class: 'card-click'
    })[0].click();
  },
  convertImgParams: function (params) {
    var w = params.width;
    var h = params.height;
    params.unit = params.unit ? params.unit : 'px';
    var ratio = params.width / params.height;
    if (params.baseWidth) {
      w = params.baseWidth;
      h = (w / ratio);
    }
    if (params.baseHeight) {
      h = params.baseHeight;
      w = h * ratio;
    }

    return {
      width: w + params.unit,
      height: h + params.unit
    };
  },
  insertHtmlAtCaret: function (html) {
    var sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        // Range.createContextualFragment() would be useful here but is
        // non-standard and not supported in all browsers (IE9, for one)
        var el = document.createElement("div");
        el.innerHTML = html;
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    } else if (document.selection && document.selection.type !== "Control") {
      // IE < 9
      document.selection.createRange().pasteHTML(html);
    }
  },
  getCursortPosition: function (element) {
    var caretOffset = 0;
    var sel;
    if (typeof window.getSelection != "undefined") {//谷歌、火狐
      sel = window.getSelection();
      if (sel.rangeCount > 0) {//选中的区域
        var range = window.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();//克隆一个选中区域
        preCaretRange.selectNodeContents(element);//设置选中区域的节点内容为当前节点
        preCaretRange.setEnd(range.endContainer, range.endOffset);  //重置选中区域的结束位置
        caretOffset = preCaretRange.toString().length;
      }
    } else if ((sel = document.selection) && sel.type != "Control") {//IE
      var textRange = sel.createRange();
      var preCaretTextRange = document.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint("EndToEnd", textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  },
  setEndOfContenteditable: function (contentEditableElement) {
    var range, selection;
    if (document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
      range = document.createRange();//Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
      range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection();//get the selection object (allows you to change selection)
      selection.removeAllRanges();//remove any selections already made
      selection.addRange(range);//make the range you have just created the visible selection
    }
    else if (document.selection)//IE 8 and lower
    {
      range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
      range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
      range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
      range.select();//Select the range (make it the visible selection
    }
  },
  getInsertEmojiCursor: function (value, location) {
    //let obj = this.richEditor; //当前的输入框
    var range, node;
    // if (!obj.hasfocus) {
    //   obj.focus();
    // } //兼容浏览器
    if (window.getSelection && window.getSelection().getRangeAt) {
      range = location; //获取输入框失去焦点时的光标位置
      range.collapse(false);
      node = range.createContextualFragment(value); //将value创建为DocumentFragment对象，包含一个或多个子孙节点
      var c = node.lastChild;
      range.insertNode(node); //插入DocumentFragment对象
      if (c) {
        //有子节点的情况
        range.setEndAfter(c); //结束点设置为紧邻指定节点的节点之后
        range.setStartAfter(c); //开始点设置为紧邻指定节点的节点之后
      }
      var j = window.getSelection();
      j.removeAllRanges(); //清除选择内容
      j.addRange(range);
    } else if (document.selection && document.selection.createRange) {
      //IE
      document.selection.createRange().pasteHTML(value);
    }
    //this.richEditor.scrollTop = this.richEditor.scrollHeight;
  },
  getClipboardData: function (e) {
    var clipboardData = e.originalEvent.clipboardData || e.clipboardData || window.clipboardData;
    if (!clipboardData) {
      return null;
    }
    var fs;
    var text;
    if (clipboardData.items && clipboardData.items.length) {
      for (var i = 0; i < clipboardData.items.length; i++) {
        var item = clipboardData.items[i];
        if (item.kind == 'file' && item.type.match(/^image\//i)) {
          fs = item.getAsFile();
        } else if (item.kind == 'string' && item.type == 'text/plain') {
          text = clipboardData.getData('text/plain')
        }
      }
    } else if (clipboardData.types && clipboardData.types.length) {
      for (var j = 0; j < clipboardData.types.length; j++) {
        if (clipboardData.types[j] == 'text/plain') {
          text = clipboardData.getData('text/plain')
        }
      }
    } else if (clipboardData && clipboardData.getData) {
      text = window.clipboardData.getData('Text');
    } else if (clipboardData.files && clipboardData.files.length) {
      fs = clipboardData.files[0];
    }
    return text ? { type: 'text', content: text } : fs ? { type: 'file', content: fs } : null;
  },
  getImgParams: function (options) {
    var minsize = options.minsize,
      maxsize = options.maxsize,
      width,
      height,
      imagParamsObj;
    if (!options.image_width || !options.image_height) {
      imagParamsObj = {
        url: options.url,
        background_size: 'cover',
        width: 250,
        height: 150,
        repeat: 'no-repeat'
      };
      return imagParamsObj;
    }

    if (options.image_width > options.image_height) {
      var ratio = options.image_width / options.image_height;
      if (ratio > maxsize / minsize) {
        height = minsize;
        width = maxsize;
      }
      else {
        if (options.image_width > maxsize) {
          width = maxsize;
          height = width / ratio;
        }
        else {
          width = options.image_width;
          height = options.image_height;
        }
      }
    }
    else {
      var ratio = options.image_height / options.image_width;
      if (ratio > maxsize / minsize) {
        width = minsize;
        height = maxsize;
      }
      else {
        if (options.image_height > maxsize) {
          height = maxsize;
          width = height / ratio;
        }
        else {
          width = options.image_width;
          height = options.image_height;
        }
      }
    }

    var src;
    if (options.url && options.url.indexOf('data:') === -1) {
      src = options.url + '?crop=1' + '&cpos=northwest' + '&h=' + height + '&w=' + width;
    }
    else {
      src = options.url;
    }

    var background_size = '';
    if (height == minsize && width == maxsize) {
      background_size = 'auto 100%';
    }
    else if (height == maxsize && width == minsize) {
      background_size = '100% auto';
    }
    else {
      background_size = '100% 100%';
    }

    return {
      url: src,
      background_size: background_size,
      width: width,
      height: height
    }
  },
  isEmpty: _isEmpty,
  jsonHandler: _jsonHandler,
  isGroupUser: _isGroupUser,
  isShopModeUser: _isShopModeUser,
  isShopModeUserSource: _isShopModeUserSource,
  isAnonymousSession: _isAnonymousSession,
  getShopKey: _getShopKey,
  is_file_helper: function (userId, userSource) {
    return userId === 'wjzs10000' && userSource === 108;
  },
  is_remind_helper: function (userId, userSource, shop_id, shop_source) {
    return userId === '75969072527136' && userSource === 1999 && _isEmpty(shop_id) && _isEmpty(shop_source);
  },
  IEVersion: function () {
    if (PLATFORM_ENV === 'xcx') {
      return false;
    }
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      if (fIEVersion == 7) {
        return 7;
      } else if (fIEVersion == 8) {
        return 8;
      } else if (fIEVersion == 9) {
        return 9;
      } else if (fIEVersion == 10) {
        return 10;
      } else {
        return 6;//IE版本<=7
      }
    } else if (isEdge) {
      return 'edge';//edge
    } else if (isIE11) {
      return 11; //IE11  
    } else {
      return -1;//不是ie浏览器
    }
  },
  compareBigNumber: _compareBigNumber,
  sumBigNumber: function (a, b) {
    var res = '',
      temp = 0;
    a = a.split('');
    b = b.split('');
    while (a.length || b.length || temp) {
      temp += ~~a.pop() + ~~b.pop();
      res = (temp % 10) + res;
      temp = temp > 9;
    }
    return res.replace(/^0+/, '');
  },
  subBigNumber: function (a, b) {
    var larger;
    var lesser;
    var compareThem = _compareBigNumber(a, b);
    if (compareThem === 0) {
      return 0
    } else if (compareThem === 1) {
      larger = a;
      lesser = b;
    } else if (compareThem === -1) {
      larger = b;
      lesser = a;
    }
    var res = '',
      temp = 0,
      subPrevious = false;
    larger = larger.split('');
    lesser = lesser.split('');
    while (larger.length || lesser.length) {
      temp = ~~larger.pop() - (~~lesser.pop() + (subPrevious ? 1 : 0));
      if (larger.length >= 1 && temp < 0) {
        temp += 10;
        subPrevious = true;
      } else {
        subPrevious = false;
      }
      res = temp + res;
    }
    return compareThem * res.replace(/^0+/, '');
  },
  strToNumCompare: _strToNumCompare,
  queque: queque,
  isPhone: function (phone) {
    if (!phone) {
      return true
    }
    return (/^1[3456789]\d{9}$/.test(phone))
  },
  isWechat: function (wechat) {
    if (!wechat) {
      return true
    }

    return (/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})$/.test(wechat))
  },
  asynchPipe: asynchPipe,
  isEmojiCharacter: function (codePoint) {
    var regStr = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/g
    return regStr.test(codePoint)
  },
  ymdhFormat: _ymdhFormat,
  isObjectValueEqual:_isObjectValueEqual
};
